import { Modal, ModalOverlay, ModalBody, ModalContent, ModalCloseButton } from '@chakra-ui/react';
import Receipt from './Receipt';
import { useNavigate, useLocation } from 'react-router-dom';
import { useInvoices } from '../hooks/useInvoices';
import PaymentModalStatusContext from '../contexts/PaymentModalStatusContext';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import { useContext } from 'react';

const PaymentModalStatus = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refetch } = useInvoices();
  const { refetchActive } = useContext(SubscriptionsContext);

  const { invoiceIds, setInvoiceIds } = useContext(PaymentModalStatusContext);

  const closeModalHandler = () => {
    setInvoiceIds([]);
    navigate(location.pathname, { replace: true });
    refetch();
    refetchActive();
  };

  return (
    <Modal isOpen={!!invoiceIds.length} onClose={closeModalHandler} isCentered={true} size={['md', 'md', 'lg', '2xl']}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Receipt txnId={invoiceIds} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PaymentModalStatus;
